<template>
  <el-dialog
    class="detectionCode"
    title="请输入验证码"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <el-form
      autocomplete="on"
      ref="numberValidateForm"
      label-position="left"
      :model="captchaForm"
      @submit.native.prevent
    >
      <el-form-item
        :error="errorVerificationMsg"
        class="verification-item"
        style="margin-top: 20px;"
        prop="captcha_answer"
        :rules="[{ required: true, message: '验证码不能为空' }]"
      >
        <el-input
          style="width: 280px;"
          v-model="captchaForm.captcha_answer"
          placeholder="4位验证码"
          clearable
        ></el-input>
        <img
          style="margin-left: 10px;width:88px;height:40px"
          :src="imgsrc"
          @click="handleImgSrc"
        />
      </el-form-item>

      <div class="cen">
        <span slot="footer" class="dialog-footer cen">
          <el-button
            type="primary"
            @click="handleCaptcha_value"
            :loading="loading"
            >发送验证码</el-button
          >
        </span>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { validateImgCode } from '@/utils/validate';
import { errorHandle } from '../../../utils/error';

export default {
  name: 'DialogValidation',
  props: {
    phone: String,
    dialogVisible: Boolean
  },
  data() {
    return {
      captchaForm: {
        captcha_id: '',
        captcha_answer: ''
      },
      errorVerificationMsg: null,
      loading: false,
      totalTime: 60,
      content: '获取验证码',
      imgsrc: ''
    };
  },
  mounted() {
    this.handleImgSrc();
  },
  methods: {
    handleCaptcha_value() {
      this.errorVerificationMsg = null;
      this.$refs.numberValidateForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const obj = this.captchaForm;
          obj.phone_nbr = this.phone;
          this.$store
            .dispatch('Sendsms', obj)
            .then(() => {
              this.loading = false;
              this.$emit('countDown');
            })
            .catch((err) => {
              this.loading = false;
              validateImgCode(err.code, (msg, errname) => {
                this.errorVerificationMsg =
                  (errname === 'errorVerificationMsg' && msg) || null;
              });
              this.handleImgSrc();
            });
        }
      });
    },
    handleClose() {
      this.$emit('handleClose');
      this.$refs.numberValidateForm.resetFields();
    },

    handleImgSrc() {
      this.$store
        .dispatch('Verification')
        .then((res) => {
          if (res) {
            this.captchaForm.captcha_id = res.id;
            this.imgsrc = res.data;
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    }
  }
};
</script>

<style lang="scss">

.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}
.verification-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
.detectionCode {
  .loginForm {
    padding: 0px !important;
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }
  .loginForm .head {
    margin: 0px 0px;
  }
  .el-dialog {
    width: 460px;
  }
  .el-dialog__body {
    padding: 0px 5px 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/VerificationCode/index.vue